<template>
  <div>
    <table class="table is-fullwidth" ref="filesTable">
      <thead>
        <tr>
          <th v-if="addFileAvailable"></th>
          <th v-t="'Admin.status'"></th>
          <th v-t="'Admin.name'"></th>
          <th v-t="'Admin.file'"></th>
          <th v-t="'Admin.size'"></th>
          <th v-t="'Admin.actions'"></th>
        </tr>
      </thead>
      <draggable :element="'tbody'" :list="files" @end="$emit('input', files)">
        <tr v-for="(file) in files" :key="file.id" class="boxed-row">
          <td class="has-text-centered" v-if="addFileAvailable">
            <span class="icon">
              <i class="fas fa-arrows-alt-v"></i>
            </span>
          </td>
          <td>
            <a class="button" :class="computeFileStatus(file)">
              <span class="icon is-small">
                <i class="fas" :class="iconStyle(file) "></i>
              </span>
            </a>
          </td>
          <td class="field">
            <div class="control">
              <input class="input" type="text" v-model="file.fileName">
            </div>
          </td>
          <td>{{file.fileName}}</td>
          <td>{{file.size}}</td>
          <td class="buttons">
            <a
              class="button is-danger"
              @click="openDialog( '',file) "
            >
              <span class="icon is-small">
                <i class="fas fa-trash"></i>
              </span>
            </a>
            <a class="button is-info" @click="previewFile(file)" v-if="file.status==='success' ">
              <span class="icon is-small">
                <i class="fas fa-eye"></i>
              </span>
            </a>
          </td>
        </tr>
      </draggable>
    </table>
    <div class="file is-primary" v-if="addFileAvailable">
      <label class="file-label">
        <div class="file">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              :accept="fieldProperties.fileType+'/*'"
              @change="handleFile"
              multiple="true"
            >
            <span class="file-cta">
              <span class="file-label" v-t="'Admin.add'"></span>
            </span>
          </label>
        </div>
      </label>
    </div>
    <aux-modal-dialog :active.sync="showModal"></aux-modal-dialog>
  </div>
</template>
<script>
import { inputProps } from '@/mixins/FormInputMixin'
import { mapActions } from 'vuex'
import axios from 'axios'
import _ from 'underscore'
import AuxModalDialog from '@/components/AuxModalDialog'
import Draggable from 'vuedraggable'
export default {
  mounted () {
    this.files = _.values(this.value)
  },
  components: { AuxModalDialog, Draggable },
  watch: {
    value: function (value) {
      this.files = _.values(this.value)
    },
    files: {
      deep: true,
      handler: function () {
        this.$emit('update:canSave', this.filesStatus)
      } }
  },
  props: ['formType'],
  mixins: [inputProps],
  data () {
    return { files: [], showModal: false }
  },
  computed: {
    addFileAvailable: function () {
      if (this.fieldProperties.multiple !== 'true' && this.files.length >= 1) {
        return false
      } else {
        return true
      }
    },
    filesStatus () {
      return _.every(this.files, file => {
        return file.status === 'success'
      })
    }
  },
  methods: {
    ...mapActions(['upload', 'getCapsuleFiles']),
    sort: function () {
      this.files = _.shuffle(this.files)
    },
    moveUp: function (index) {
      this.files.splice(index - 1, 0, this.files.splice(index, 1)[0])
    },
    moveDown: function (index) {
      this.files.splice(index + 1, 0, this.files.splice(index, 1)[0])
    },
    handleFile: function (ev) {
      // var self = this
      if (ev.target.files) {
        _.each(
          ev.target.files,
          function (file) {
            let f = {
              fileName: file.name,
              size: file.size,
              id: file.id,
              status: 'uploading'
            }
            this.files.push(f)
            this.$emit('input', this.files)
            var data = new FormData()
            data.append('file', file)
            axios
              .post(
                process.env.VUE_APP_ROOT_API +
                  '/api/data/uploadFile/' +
                  this.formType || 'projects',
                data,
                {
                  headers: {
                    Authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
                  onUploadProgress: progress => {
                  }
                }
              )
              .then(result => {
                // f.id = result.data.id
                f.status = 'success'
                delete result.data._id // FIXME
                _.extend(f, result.data)
                // this.$emit('input', _.pluck(this.files, 'id'))
              })
              .catch(result => {
                f.status = 'error'
              })
          },
          this
        )
      }

      /* if (ev.target) {
        var fileReader = new FileReader()
        fileReader.readAsDataURL(ev.target.files[0])
        fileReader.onloadend = function() {
          self.files.push(fileReader.result)
          self.$refs.quill.quill.insertEmbed(1, 'image', fileReader.result)
          self.showModal = false
        }
      } else {
        self.$refs.quill.quill.insertEmbed(1, 'image', ev)
        self.showModal = false
      } */
      // this.emitChange()
    },
    previewFile: function (file) {
      window.open(file.fileUrl)
    },

    openDialog (type, file) {
      var self = this
      let obj = {
        title: 'Acció destructiva!',
        message: 'Si us plau confirma que vols eliminar el contingut',
        type: 'warning',
        customConfirmBtnText: 'Esborrar',
        customConfirmBtnClass: 'button is-danger',
        customCloseBtnText: 'Cancel.lar',
        customCloseBtnClass: 'button is-info',
        useConfirmBtn: true,
        onConfirm: function () {
          self.requestDelete(file)
        }
      }
      this.$Simplert.open(obj)
    },
    requestDelete: function (file) {
      if (!file.id) {
        this.files = _.without(this.files, file)
        return this.$emit('input', this.files)
      }
      this.$store
        .dispatch('deleteFile', { data: { id: file.id } })
        .then(result => {
          this.files = _.without(this.files, file)
          this.$emit('input', this.files)
        })
    },
    computeFileStatus: function (file) {
      return {
        // 'is-loading': file.status === 'uploading',
        'is-info': file.status === 'uploading',
        'is-warning': file.status === 'paused',
        'is-danger': file.status === 'error',
        'is-success': file.status === 'success'
      }
    },
    iconStyle: function (file) {
      return {
        'fa-spinner fa-spin': file.status === 'uploading',
        'fa-exclamation-triangle': file.status === 'paused',
        'fa-check': file.status === 'success'
      }
    }
  },
  name: 'form-file'
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 1s;
}

td {
  vertical-align: middle;
}
.boxed-row {
  border: solid 1px grey;
}
</style>
